/* Shared HNG-04 header search behavior for the product and cart pages. */
(() => {
  const setupRegionDialog = () => {
    const dialog = document.querySelector('#hn-ui-region-dialog');
    if (!dialog || document.body.dataset.hnUiRegionReady) return;
    document.body.dataset.hnUiRegionReady = 'true';
    document.body.append(dialog);
    let lastTrigger;
    let closing = false;
    let closeTimer;
    const openDialog = (openedByPointer = false) => {
      if (dialog.open) return;
      clearTimeout(closeTimer);
      closing = false;
      dialog.classList.toggle('is-pointer-open', openedByPointer);
      dialog.showModal();
      requestAnimationFrame(() => requestAnimationFrame(() => dialog.classList.add('is-visible')));
      dialog.querySelector('select')?.focus();
    };
    const closeDialog = () => {
      if (!dialog.open || closing) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        dialog.close();
        return;
      }
      closing = true;
      dialog.classList.remove('is-visible');
      closeTimer = window.setTimeout(() => dialog.close(), 400);
    };
    document.addEventListener('click', (event) => {
      const trigger = event.target?.closest?.('.hn-ui-region-open, .hn-ui-country > summary, .hn-ui-footer__region > summary');
      if (!trigger) return;
      event.preventDefault();
      trigger.closest('details')?.removeAttribute('open');
      const drawerClose = trigger.closest('.hn-mobile-menu-shell') && document.querySelector('#Details-menu-drawer-container[open] button.menu-drawer__close-button[aria-label="Close"]');
      lastTrigger = drawerClose ? document.querySelector('summary[aria-label="Menu"]') : trigger;
      drawerClose?.click();
      openDialog(event.detail > 0);
    });
    dialog.querySelector('.hn-ui-region-dialog__close')?.addEventListener('click', closeDialog);
    dialog.querySelector('form')?.addEventListener('submit', (event) => {
      const country = dialog.querySelector('select[name="country_code"]');
      if (!country?.selectedOptions[0]?.defaultSelected) return;
      event.preventDefault();
      closeDialog();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) closeDialog();
    });
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDialog();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape' || !dialog.open) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      closeDialog();
    }, { capture: true });
    dialog.addEventListener('close', () => {
      clearTimeout(closeTimer);
      dialog.classList.remove('is-visible', 'is-pointer-open');
      closing = false;
      lastTrigger?.focus();
    });
  };
  const init = () => {
    setupRegionDialog();
    if (!document.querySelector('.hn-reference-header .hn-header-search')) return;
    const searchRoot = () => document.querySelector('.hn-reference-header .hn-header-search');
    const searchOverlay = document.createElement('div');
    searchOverlay.className = 'hn-ui-search-overlay';
    document.body.append(searchOverlay);
    const syncSearchOverlay = () => {
      const search = searchRoot();
      const input = search?.querySelector('#hn-header-search-input');
      const trending = search?.querySelector('#hn-ui-trending');
      const results = search?.querySelector('#hn-header-search-results');
      const mobile = window.matchMedia('(max-width: 1024px)').matches;
      const keyboardNavFocus = window.matchMedia('(min-width: 1025px)').matches
        && document.querySelector('.hn-reference-header__nav')?.contains(document.activeElement)
        && search?.classList.contains('is-active')
        && !trendingDismissed;
      const resultsOpen = Boolean(mobile && input?.value.trim() && results && !results.hidden);
      const active = Boolean(search?.contains(document.activeElement) || keyboardNavFocus || resultsOpen);
      search?.classList.toggle('is-active', active);
      search?.classList.toggle('is-empty', Boolean(active && mobile && !input?.value.trim()));
      const cancel = search?.querySelector('.hn-ui-search-cancel');
      if (cancel) cancel.hidden = !(active && mobile);
      searchOverlay.classList.toggle('is-visible', Boolean(active && ((!trending?.hidden) || input?.value.trim())));
    };
    searchOverlay.addEventListener('pointerdown', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const search = searchRoot();
      const input = search?.querySelector('#hn-header-search-input');
      const trending = search?.querySelector('#hn-ui-trending');
      const results = search?.querySelector('#hn-header-search-results');
      trendingDismissed = true;
      if (trending) trending.hidden = true;
      if (results) results.hidden = true;
      input?.blur();
      syncSearchOverlay();
    });
    searchRoot()?.querySelector('.hn-ui-search-cancel')?.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      const search = searchRoot();
      const input = search?.querySelector('#hn-header-search-input');
      const trending = search?.querySelector('#hn-ui-trending');
      const results = search?.querySelector('#hn-header-search-results');
      search?.dismissInlineResults?.();
      trendingDismissed = true;
      if (trending) trending.hidden = true;
      if (results) results.hidden = true;
      input?.setAttribute('aria-expanded', 'false');
      input?.blur();
      event.currentTarget.blur();
      syncSearchOverlay();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' || event.target?.id !== 'hn-header-search-input') return;
      const input = event.target;
      if (!input.value.trim()) return;
      const form = input.closest('form');
      if (!form) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      form.requestSubmit(form.querySelector('.hn-header-search__submit'));
    }, { capture: true });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' || event.target?.id !== 'hn-header-search-input') return;
      // Native Tab order matches the reference's visible Search and Trending
      // controls; the shared predictive component otherwise cycles hidden results.
      event.stopImmediatePropagation();
    }, { capture: true });
    let trendingDismissed = false;
    const dismissSearchForNavigation = () => {
      const search = searchRoot();
      const input = search?.querySelector('#hn-header-search-input');
      const trending = search?.querySelector('#hn-ui-trending');
      const results = search?.querySelector('#hn-header-search-results');
      trendingDismissed = true;
      if (trending) trending.hidden = true;
      if (results) results.hidden = true;
      if (document.activeElement === input) input.blur();
      syncSearchOverlay();
    };
    const nav = document.querySelector('.hn-reference-header__nav');
    nav?.addEventListener('pointerenter', dismissSearchForNavigation);
    const syncTrending = () => {
      const search = searchRoot();
      const input = search?.querySelector('#hn-header-search-input');
      const panel = search?.querySelector('#hn-ui-trending');
      const clear = search?.querySelector('.hn-header-search__clear');
      if (clear && input) clear.hidden = !input.value.trim();
      if (panel && input) {
        const keyboardNavFocus = window.matchMedia('(min-width: 1025px)').matches
          && nav?.contains(document.activeElement)
          && search?.classList.contains('is-active');
        panel.hidden = trendingDismissed || !((search?.contains(document.activeElement) || keyboardNavFocus) && !input.value.trim());
      }
      syncSearchOverlay();
    };
    const clearHngSearch = (event) => {
      if (!event.target?.closest?.('.hn-reference-header .hn-header-search__clear')) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const input = searchRoot()?.querySelector('#hn-header-search-input');
      if (!input) return;
      input.value = '';
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
      trendingDismissed = false;
      syncTrending();
    };
    // Capture pointerdown before the browser moves focus to Clear and the
    // active search layout reflows. Keep click for keyboard activation.
    document.addEventListener('pointerdown', clearHngSearch, { capture: true });
    document.addEventListener('click', clearHngSearch, { capture: true });
    const predictiveResults = searchRoot()?.querySelector('#hn-header-search-results');
    if (predictiveResults) new MutationObserver(syncSearchOverlay).observe(predictiveResults, { attributes: true, attributeFilter: ['hidden'] });
    const searchInput = searchRoot()?.querySelector('#hn-header-search-input');
    if (searchInput) new MutationObserver(syncSearchOverlay).observe(searchInput, { attributes: true, attributeFilter: ['aria-expanded'] });
    const regionPickers = document.querySelectorAll('.hn-ui-region-picker, .hn-ui-country');
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      regionPickers.forEach((picker) => picker.removeAttribute('open'));
      const search = searchRoot();
      const input = search?.querySelector('#hn-header-search-input');
      const panel = search?.querySelector('#hn-ui-trending');
      if (document.activeElement === input) return;
      if (panel && !panel.hidden) {
        event.preventDefault();
        trendingDismissed = true;
        panel.hidden = true;
        syncSearchOverlay();
      }
    }, { capture: true });
    document.addEventListener('pointerdown', (event) => {
      regionPickers.forEach((picker) => {
        if (!picker.contains(event.target)) picker.removeAttribute('open');
      });
    });
    document.addEventListener('focusin', (event) => {
      if (event.target?.id === 'hn-header-search-input') {
        trendingDismissed = false;
        syncTrending();
      } else {
        requestAnimationFrame(syncTrending);
      }
    });
    document.addEventListener('input', (event) => {
      if (event.target?.id === 'hn-header-search-input') {
        trendingDismissed = false;
        syncTrending();
      }
    });
    document.addEventListener('focusout', (event) => {
      if (event.target?.id === 'hn-header-search-input') requestAnimationFrame(syncTrending);
    });
    document.addEventListener('pointerdown', (event) => {
      const search = searchRoot();
      const panel = search?.querySelector('#hn-ui-trending');
      if (panel && search.contains(event.target)) {
        trendingDismissed = false;
        requestAnimationFrame(syncTrending);
      } else if (panel) {
        trendingDismissed = true;
        panel.hidden = true;
        syncSearchOverlay();
      }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
